if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const addonVariantIds = formData.getAll('addon_variant_id').filter(Boolean);
        formData.delete('addon_variant_id');

        const requestedQuantity = Number.parseInt(formData.get('quantity'), 10);
        const mainItemQuantity = Number.isNaN(requestedQuantity) || requestedQuantity < 1 ? 1 : requestedQuantity;

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          let cartRenderResponse = response;

          if (addonVariantIds.length) {
            const addonResponse = await this.addAddonItems(
              addonVariantIds,
              mainItemQuantity,
              this.cart,
              response.key
            );
            if (addonResponse && addonResponse.sections) {
              cartRenderResponse = addonResponse;
            }
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: cartRenderResponse,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(cartRenderResponse);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(cartRenderResponse);
              });
            }
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
        }
      }

      async addAddonItems(addonVariantIds, quantity, cart = null, notificationKey = null) {
        let lastSectionedResponse = null;

        for (let index = 0; index < addonVariantIds.length; index++) {
          const addonVariantId = addonVariantIds[index];
          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete addonConfig.headers['Content-Type'];

          const addonFormData = new FormData();
          addonFormData.append('id', addonVariantId);
          addonFormData.append('quantity', quantity);

          const includeSections = Boolean(cart) && index === addonVariantIds.length - 1;
          if (includeSections) {
            addonFormData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id)
            );
            addonFormData.append('sections_url', window.location.pathname);
          }

          addonConfig.body = addonFormData;

          try {
            const response = await fetch(`${routes.cart_add_url}`, addonConfig).then((response) => response.json());
            if (response.status) {
              console.error('Add-on product could not be added:', response.description || response.message);
              continue;
            }

            if (includeSections && response.sections) {
              if (notificationKey) {
                response.key = notificationKey;
              }
              lastSectionedResponse = response;
            }
          } catch (error) {
            console.error('Add-on product request failed:', error);
          }
        }

        return lastSectionedResponse;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
